import { render } from "./BetaMannosidosisLeukocytes.vue?vue&type=template&id=ab54022e&scoped=true"
import script from "./BetaMannosidosisLeukocytes.vue?vue&type=script&lang=js"
export * from "./BetaMannosidosisLeukocytes.vue?vue&type=script&lang=js"

import "./BetaMannosidosisLeukocytes.vue?vue&type=style&index=0&id=ab54022e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab54022e"]])

export default __exports__